import heroImage from "../assets/figma/hero.png";
import media2 from "../assets/figma/media-2.png";
import { Container, SiteFooter, SiteHeader } from "./SiteChrome";
import { useCmsBatch } from "../hooks/useCmsBatch";
import { CmsIcon } from "../utils/cmsIcons";

const zonesDefault = [
  { icon: "Dumbbell", title: "Turf Arenas", body: "Premium, weather-proof turf arenas built for small-sided games, private sessions, and rentals." },
  { icon: "Gauge", title: "Performance Lab", body: "Wearable-backed testing across speed, agility, technique, and decision-making." },
  { icon: "ShieldCheck", title: "Recovery Zone", body: "Structured rehab and recovery work that bridges the clinic and competition." },
  { icon: "Users", title: "Player Lounge", body: "A space for players and families to unwind between sessions." },
];

const gallery = [
  [heroImage, "Assessment testing on the SpeedCourt"],
  [media2, "Training inside the turf arena"],
];

const CMS_KEYS = ["facility-hero", "facility-zones"];

export function FacilityPage() {
  const { content } = useCmsBatch(CMS_KEYS);
  const hero = content["facility-hero"] || {};
  const zonesSection = content["facility-zones"] || {};
  const zones = zonesSection.items?.length ? zonesSection.items : zonesDefault;

  return (
    <>
      <SiteHeader />
      <main>
        <section className="section dark">
          <Container className="grid-12">
            <div className="section-copy">
              <p className="eyebrow lime"><span>01</span>Facility</p>
              <h2>{hero.title || "Step inside the lab."}</h2>
              <p style={{ color: "var(--muted)", lineHeight: 1.8, marginTop: 16 }}>
                {hero.body || "Formula Soccer Center is built around one idea: measurable progress. Every zone of the facility is designed to support that, from first touch to elite performance."}
              </p>
            </div>
            <div className="media-split-image">
              <img src={hero.mediaUrl || heroImage} alt="Formula Soccer Center training lab" />
            </div>
          </Container>
        </section>

        <section className="section light">
          <Container>
            <p className="eyebrow"><span>02</span>Inside the facility</p>
            <h2 style={{ fontSize: "clamp(32px, 4vw, 52px)" }}>{zonesSection.title || "Four zones, one goal."}</h2>
            <div className="value-grid">
              {zones.map((zone) => (
                <div key={zone.title} className="value-card">
                  <div className="value-card-icon"><CmsIcon name={zone.icon} size={20} strokeWidth={1.5} /></div>
                  <h3>{zone.title}</h3>
                  <p>{zone.body}</p>
                </div>
              ))}
            </div>
          </Container>
        </section>

        <section className="section dark">
          <Container>
            <p className="eyebrow lime"><span>03</span>Gallery</p>
            <h2 style={{ fontSize: "clamp(32px, 4vw, 52px)" }}>A closer look.</h2>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 24, marginTop: 32 }}>
              {gallery.map(([src, caption]) => (
                <figure key={src} style={{ margin: 0 }}>
                  <img
                    src={src}
                    alt={caption}
                    style={{ width: "100%", height: 300, objectFit: "cover", border: "1px solid var(--dark-rule)" }}
                  />
                  <figcaption style={{ marginTop: 10, fontSize: 12, color: "var(--muted)" }}>{caption}</figcaption>
                </figure>
              ))}
            </div>
          </Container>
        </section>
      </main>
      <SiteFooter />
    </>
  );
}
